export default "assets/images/queue-home2-66461ba9.png";